export const FINANCE_ICONS = {
  wallet: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Objects/Money%20Bag.png",
  coin: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Objects/Coin.png",
  chart: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Objects/Chart%20Increasing.png",
  calendar: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Objects/Calendar.png",
  money_bag: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Objects/Money%20Bag.png",
};

export const FINANCE_CATEGORIES = ["식비", "교통비", "간식", "물품구매", "행사비", "기타"];

const CATEGORY_ICON_MAP = {
  식비: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Food/Fork%20and%20Knife%20with%20Plate.png",
  교통비: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Travel%20and%20places/Bus.png",
  간식: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Food/Hot%20Beverage.png",
  물품구매: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Objects/Shopping%20Bags.png",
  행사비: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Activities/Party%20Popper.png",
  default: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Objects/Spiral%20Notepad.png",
};

const CATEGORY_COLOR_MAP = {
  식비: "bg-orange-400",
  교통비: "bg-blue-400",
  간식: "bg-yellow-400",
  물품구매: "bg-purple-400",
  행사비: "bg-rose-400",
  default: "bg-gray-400",
};

export const getFinanceCategoryIcon = (category) => CATEGORY_ICON_MAP[category] || CATEGORY_ICON_MAP.default;

export const getFinanceCategoryColor = (category) => CATEGORY_COLOR_MAP[category] || CATEGORY_COLOR_MAP.default;
